/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';

export const useSyncHorizontalScroll = (tableHeadRef, scrollRef) => {
  useEffect(() => {
    const handleTableHeadScroll = () => {
      if (scrollRef.current && scrollRef.current._outerRef) {
        scrollRef.current._outerRef.scrollLeft = tableHeadRef.current.scrollLeft;
      }
    };

    const handleListScroll = () => {
      if (tableHeadRef.current && scrollRef.current && scrollRef.current._outerRef) {
        tableHeadRef.current.scrollLeft = scrollRef.current._outerRef.scrollLeft;
      }
    };

    const tableHeadElement = tableHeadRef.current;
    const listElement = scrollRef.current?._outerRef;

    if (tableHeadElement && listElement) {
      tableHeadElement.addEventListener('scroll', handleTableHeadScroll);
      listElement.addEventListener('scroll', handleListScroll);
    }

    return () => {
      if (tableHeadElement && listElement) {
        tableHeadElement.removeEventListener('scroll', handleTableHeadScroll);
        listElement.removeEventListener('scroll', handleListScroll);
      }
    };
  }, [tableHeadRef, scrollRef.current]);
};